(() => {
  'use strict';
  const query = (selector, context = document) => context.querySelector(selector);
  const queryAll = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const menu = query('[data-wh13-mobile-menu]');
  const menuButton = query('[data-wh13-menu-open]');
  const setMenu = (open) => {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    menuButton?.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) query('.wh13-mobile-menu__panel', menu)?.focus();
  };

  menuButton?.addEventListener('click', () => setMenu(true));
  queryAll('[data-wh13-menu-close]').forEach((button) => button.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  queryAll('[data-wh13-video]').forEach((video) => {
    video.addEventListener('play', () => {
      queryAll('[data-wh13-video]').forEach((other) => {
        if (other !== video) other.pause();
      });
    });
  });

  const backStorageKey = 'whitehole:lastListingState:v133';
  const listingPathPattern = /^\/(collections(?:\/|$)|search(?:\/|$))/;
  const isListingUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && listingPathPattern.test(url.pathname);
    } catch (_) {
      return false;
    }
  };
  const isListingPage = () => listingPathPattern.test(window.location.pathname);
  const isProductPage = () => /^\/products\//.test(window.location.pathname);
  const currentRelativeUrl = () => window.location.pathname + window.location.search + window.location.hash;

  const readListingState = () => {
    try {
      const state = JSON.parse(sessionStorage.getItem(backStorageKey) || 'null');
      if (!state?.url || !isListingUrl(state.url)) return null;
      if (state.savedAt && Date.now() - Number(state.savedAt) > 6 * 60 * 60 * 1000) return null;
      return state;
    } catch (_) {
      return null;
    }
  };

  const saveListingState = (productPath = null) => {
    if (!isListingPage()) return;
    const url = currentRelativeUrl();
    const previous = readListingState();
    const preservedProductPath = productPath || (previous?.url === url ? previous.productPath : null);
    try {
      sessionStorage.setItem(backStorageKey, JSON.stringify({
        url,
        productPath: preservedProductPath || null,
        scrollY: Math.max(0, Math.round(window.scrollY || 0)),
        savedAt: Date.now()
      }));
    } catch (_) {}
  };

  saveListingState();
  window.addEventListener('pagehide', () => saveListingState(), { passive: true });

  document.addEventListener('click', (event) => {
    /* Capture the exact listing that launched a product. This prevents a stale
       category URL from being used when a product is opened directly. */
    if (isListingPage()) {
      const productAnchor = event.target.closest('a[href*="/products/"]');
      if (productAnchor?.href) {
        try {
          const productUrl = new URL(productAnchor.href, window.location.origin);
          if (productUrl.origin === window.location.origin) saveListingState(productUrl.pathname);
        } catch (_) {}
      }
    }

    const backButton = event.target.closest('[data-wh13-back]');
    if (backButton) {
      event.preventDefault();
      const fallback = backButton.dataset.fallback || '/';

      if (isProductPage()) {
        /* When the real previous entry is a WHITEHOLE listing, use browser
           history so Category is not added to history for a second time. */
        try {
          if (document.referrer && isListingUrl(document.referrer) && history.length > 1) {
            history.back();
            return;
          }
        } catch (_) {}

        /* Privacy settings can suppress referrer. Use only a fresh listing
           context that was recorded for this exact product. replace() avoids
           creating Product -> Category -> Product loops. */
        const stored = readListingState();
        if (stored?.url && stored?.productPath === window.location.pathname) {
          window.location.replace(stored.url);
          return;
        }

        window.location.assign(fallback);
        return;
      }

      if (isListingPage()) {
        /* Collection/search Back is an explicit exit to the WHITEHOLE home
           categories area, never history.back(). */
        window.location.assign(fallback || '/#WhiteholeCategories');
        return;
      }

      try {
        if (document.referrer && new URL(document.referrer).origin === window.location.origin && history.length > 1) {
          history.back();
          return;
        }
      } catch (_) {}
      window.location.assign(fallback);
      return;
    }

    const card = event.target.closest('.product-card-wrapper');
    if (!card) return;
    if (event.target.closest('a, button, input, select, textarea, form, details, summary, [role="button"]')) return;
    const productLink = card.querySelector('.card__heading a[href], a.full-unstyled-link[href]');
    if (productLink?.href) {
      try {
        const productUrl = new URL(productLink.href, window.location.origin);
        if (isListingPage() && productUrl.origin === window.location.origin) saveListingState(productUrl.pathname);
      } catch (_) {}
      window.location.assign(productLink.href);
    }
  });

  const updateBackButtons = () => {
    queryAll('[data-wh13-back]').forEach((button) => {
      button.classList.toggle('is-scrolled', window.scrollY > 160);
    });
  };
  updateBackButtons();
  window.addEventListener('scroll', updateBackButtons, { passive: true });
})();
